import PageHero, { usePageTitle } from "@/components/PageHero";
import SectionHeader from "@/components/SectionHeader";
import IndustriesGrid from "@/components/IndustriesGrid";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/components/Reveal";

export default function Industrias() {
  usePageTitle("Industrias | BRIK Procurement Partners");
  return (
    <>
      <PageHero
        eyebrow="Industrias"
        titleLines={["Conocemos tu industria,", "hablamos tu mismo idioma."]}
        description="Entendemos sus retos y generamos soluciones de valor para cada sector."
        image="/brand/ref-steel.webp"
        alt="Procurement industrial — bobinas de acero en planta de manufactura"
      />

      <section data-testid="industries-detail" className="bg-bone">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
          <SectionHeader
            eyebrow="Sectores"
            title="Experiencia que se traduce en mejores negociaciones."
            description="Cada industria tiene sus propias reglas de juego: materias primas, proveedores, riesgos y ciclos. Nuestro trabajo empieza por entenderlos a fondo."
          />
          <div className="mt-14">
            <IndustriesGrid />
          </div>
        </div>
      </section>

      <section data-testid="industries-band" className="relative bg-oxford diagonal-lines overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-24 text-center">
          <Reveal>
            <span className="inline-block h-px w-16 bg-gold mb-8" />
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-white leading-snug max-w-3xl mx-auto">
              Distintas industrias. <span className="text-gold">Una sola visión.</span>
            </p>
          </Reveal>
        </div>
      </section>

      <CTABand
        title="Hablemos de los retos de tu industria."
        text="Cuéntanos en qué sector opera tu empresa y encontremos juntos las oportunidades de tu cadena de suministro."
        cta="Hablemos"
      />
    </>
  );
}
